import colors from './variables.module.scss';

type Colors = {
  borderColor: string;
  menuColor: string;

  // Basic colors
  White: string;
  WhiteStatic: string;
  Black: string;
  Red: string;
  Neutral: string;

  Neutral_20: string;
  Neutral_50: string;
  Neutral_60: string;
  Neutral_80: string;
  Neutral_90: string;

  Blackcurrant_40: string;
  Blackcurrant_50: string;
  Blackcurrant_60: string;
  Blackcurrant_70: string;
  Blackcurrant_80: string;

  Blue: string;
  Blue_10: string;

  Pink: string;

  Sienna: string;
  Sienna20: string;

  Yellow: string;
  Yellow10: string;
  Yellow20: string;

  Green: string;
  Green10: string;
  Green20: string;
};

export const Colors = colors as Colors;

export const hexToRgba = (hex: string, alpha: number = 1) => {
  // Remove the hash if it exists
  hex = hex.replace('#', '');

  let r, g, b;

  // Handle 3-digit hex codes
  if (hex.length === 3) {
    r = parseInt(hex[0] + hex[0], 16);
    g = parseInt(hex[1] + hex[1], 16);
    b = parseInt(hex[2] + hex[2], 16);
  }
  // Handle 6-digit hex codes
  else if (hex.length === 6) {
    r = parseInt(hex.substring(0, 2), 16);
    g = parseInt(hex.substring(2, 4), 16);
    b = parseInt(hex.substring(4, 6), 16);
  }

  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};

export const isDarkColor = (color: string) => {
  // Check if color is in rgba format
  if (color.startsWith('rgba')) {
    const match = color.match(/rgba?\((\d+),\s*(\d+),\s*(\d+)/);
    if (match) {
      const r = parseInt(match[1], 10);
      const g = parseInt(match[2], 10);
      const b = parseInt(match[3], 10);
      const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
      return luminance < 0.5;
    }
    return false;
  }

  // Remove '#' if present
  color = color.replace('#', '');
  // Parse r, g, b for hex
  const hex =
    color.length === 3
      ? color
          .split('')
          .map((x) => x + x)
          .join('')
      : color;
  const bigint = parseInt(hex, 16);
  const r = (bigint >> 16) & 255;
  const g = (bigint >> 8) & 255;
  const b = bigint & 255;
  // Calculate luminance
  const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
  return luminance < 0.5;
};
